module.exports = __webpack_public_path__ + "img/info.08e483a0.svg";